module.exports = __webpack_public_path__ + "static/img/icon_library.7703dc71.svg";